import { ApplicationConfig, provideBrowserGlobalErrorListeners, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideQuillConfig } from 'ngx-quill';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { ConfigService } from './services/config.service';
import { AuthService } from './services/auth.service';

/**
 * Factory function to load configuration before app starts
 */
function initializeApp(): () => Promise<void> {
  const configService = inject(ConfigService);
  const authService = inject(AuthService);
  
  return async () => {
    // Load config first
    await configService.loadConfig();
    // Then load authentication so it's available for all components
    try {
      await firstValueFrom(authService.checkAuthentication());
    } catch (error) {
      console.error('Failed to load authentication:', error);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'color': [] }, { 'background': [] }],
          ['link', 'image'],
          ['clean']
        ]
      },
      theme: 'snow'
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true
    }
  ]
};
